<template>

  <form-wizard ref="add_procurement_order_form" color="#39C0ED"  @on-complete="confirmation" enctype="multipart/form-data">
    <h2 slot="title"></h2>   
    <tab-content title="Item PO" :before-change="()=>validateStep()">
      <item-card @data="dataItems"  ref="childItemComponent" />
      <md-card style="z-index:0;">
       
        <md-card-content style="">
          <div class="md-layout" style="margin-bottom:20px;">
            <div class="md-layout-item md-small-size-100">
                <md-field class="md-invalid">
                  <label for="">Remark</label>
                  <md-textarea ref="procurement_order_remark_input" v-model="procurement_order.procurement_order_remark" md-counter="100" maxlength="100" md-autogrow></md-textarea>
                  <md-avatar >
                    <md-icon style="color:blue;">report</md-icon>
                    <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                  </md-avatar>
                  <validation-error :errors="apiValidationErrors.procurement_order_remark" />
                </md-field>
              </div>
          </div>

        </md-card-content>
      </md-card>
      <!-- <item-card @data="dataItems"  ref="childItemComponent" /> -->
    </tab-content>
    <tab-content title="Attachments">
      <md-card>
        <!-- <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">
            Add Procurement Order
          </h4>
        </md-card-header> -->
        <md-card-content>
          <div class="md-layout">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:green">Attach Quotation</span>
            </label> -->
            <div class="md-layout-item md-size-100">
              <md-field class="md-invalid">
                <label for="">Attach Quotation</label>
                <md-file ref="attach_quotation" v-on:change="on_change_attach_quotation" v-model="file_attach_quotation_text" accept="image/jpeg,image/png,application/pdf,application/zip"/>
                <validation-error :errors="apiValidationErrors.file_attach_quotation_text" />
              </md-field>
              <div class="border p-2 mt-3">
                <template v-if="file_attach_quotation">
                  <img  v-if="file_attach_quotation.type==='image/jpeg' || file_attach_quotation.type==='image/png'" :src="file_attach_quotation.base64" class="img-fluid photo_list" />
                  <!-- <p class="mb-0">file name: {{ file_attach_quotation.name }}</p> -->
                  <p class="mb-0">size: {{ (file_attach_quotation.size / 1048576).toFixed(2) }}MB</p>
                </template>
              </div>
            </div>
          <!-- </div>

          <div class="md-layout"> -->
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:green">Attach PO</span>
            </label> -->
            <!-- <div class="md-layout-item md-size-100" style="margin-top:10px;">
              <md-field class="md-invalid">
                <label for="">Attach PO</label>
                <md-file ref="attach_po" @change="on_change_attach_po" v-model="file_attach_po_text" accept="image/jpeg,image/png,application/pdf"/>
                <validation-error :errors="apiValidationErrors.file_attach_po_text" />
              </md-field>
              <div class="border p-2 mt-3">
                <template v-if="file_attach_po">
                  <img v-if="file_attach_po.type==='image/jpeg' || file_attach_po.type==='image/png'" :src="file_attach_po.base64"  class="img-fluid" />
                  
                  <p class="mb-0">size: {{ (file_attach_po.size / 1048576).toFixed(2) }}MB</p>
                </template>
              </div>
            </div> -->
          <!-- </div>


          <div class="md-layout"> -->
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:green">Attach Invoice</span>
            </label> -->
            <!-- <div class="md-layout-item md-size-100" style="margin-top:10px;">
              <md-field class="md-invalid">
                <label for="">Attach Invoice</label>
                <md-file ref="attach_invoice" @change="on_change_attach_invoice" v-model="file_attach_invoice_text" accept="image/jpeg,image/png,application/pdf"/>
                <validation-error :errors="apiValidationErrors.file_attach_invoice_text" />
              </md-field>
              <div class="border p-2 mt-3">
                <template v-if="file_attach_invoice">
                  <img v-if="file_attach_invoice.type==='image/jpeg' || file_attach_invoice.type==='image/png'" :src="file_attach_invoice.base64"  class="img-fluid" />
             
                  <p class="mb-0">size: {{ (file_attach_invoice.size / 1048576).toFixed(2) }}MB</p>
                </template>
              </div>
            </div> -->
            <!-- <div class="md-layout-item md-size-100" style="margin-top:10px;">
              <md-field class="md-invalid">
                <label for="">Attach Payment</label>
                <md-file ref="attach_payment" @change="on_change_attach_payment" v-model="file_attach_payment_text" accept="image/jpeg,image/png,application/pdf"/>
                <validation-error :errors="apiValidationErrors.procurement_order_attach_payment" />
              </md-field>
              <div class="border p-2 mt-3">
                <template v-if="file_attach_payment">
                  <img v-if="file_attach_payment.type==='image/jpeg' || file_attach_payment.type==='image/png'" :src="file_attach_payment.base64"  class="img-fluid" />
            
                  <p class="mb-0">size: {{ (file_attach_payment.size / 1048576).toFixed(2) }}MB </p>
                </template>
              </div>
            </div> -->
          </div> 
        </md-card-content>
      </md-card>
    </tab-content>
  </form-wizard>
</template>

<script>
import {ValidationError} from "@/components";
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {FormWizard, TabContent} from 'vue-form-wizard'
import formMixin from "@/mixins/form-mixin";
import ItemCard from "@/pages/Dashboard/Workshop/ProcurementOrder/ComponentForm/ItemCard.vue";
import Swal from 'sweetalert2';


// validasi pesan error required field
extend('pono', {
  ...required,
  message: 'PO No field is required'
});
export default {
  name: "add-procurement-order",

  props: {
    data: Object
  },

  components: {
    FormWizard,
    TabContent,
    ValidationError,
    "item-card": ItemCard,
  },
  
  mixins: [formMixin],

  data: () => ({
    procurement_order: [],
    file_attach_quotation: null,
    file_attach_po: null,
    file_attach_invoice: null,
    // file_attach_payment: null,
    file_attach_quotation_text: null,
    file_attach_po_text: null,
    file_attach_invoice_text: null,
    // file_attach_payment_text: null,
  }),

     created() {
    },

    methods: {
     
      //fungsi untuk kembali ke list
      backtoList(id) {
      this.$router.replace({ name: 'List Procurement Order' })
    },
      resetFile(ref) {
      this.$refs[ref].clearField()
    },
      //fungsi ketika ada perubahan di attach quotation
      on_change_attach_quotation: function(event) {
        
        var input = event.target
       if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          this.resetFile('attach_quotation')
          this.file_attach_quotation_text = null
          this.file_attach_quotation = null
          return
        }
        //check apakah data ada
        if (input.files) {
          var reader = new FileReader()
          //read file
          reader.onload = (e) => {
            //set array filedata
              const fileData = {
                  name: input.files[0].name,
                  size: input.files[0].size,
                  lastModified: input.files[0].lastModified,
                  lastModifiedDate: input.files[0].lastModifiedDate,
                  type: input.files[0].type,
                  base64: e.target.result
              }
              //set var berdasarkan fildedata
              this.file_attach_quotation=fileData
            }
            reader.readAsDataURL(input.files[0])
        }
      },

      //fungsi ketika ada perubahan di attach po
      on_change_attach_po: function(event) {
        var input = event.target;
       if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          this.resetFile('attach_po')
          this.file_attach_po_text = null
          this.file_attach_po = null
          return
        }
        //check apakah data ada
        if (input.files) {
          var reader = new FileReader();
          //read file
          reader.onload = (e) => {
            //set array filedata
            const fileData = {
                  name: input.files[0].name,
                  size: input.files[0].size,
                  lastModified: input.files[0].lastModified,
                  lastModifiedDate: input.files[0].lastModifiedDate,
                  type: input.files[0].type,
                  base64: e.target.result
              }
              //set var berdasarkan fildedata
              this.file_attach_po=fileData
            }
            reader.readAsDataURL(input.files[0]);
        }
      },

      //fungsi ketika ada perubahan di attach invoice
      on_change_attach_invoice: function(event) {
        var input = event.target;
       if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          this.resetFile('attach_invoice')
          this.file_attach_invoice_text = null
          this.file_attach_invoice = null
          return
        }
        //check apakah data ada
        if (input.files) {
          var reader = new FileReader();
          //read file
          reader.onload = (e) => {
            //set array filedata
            const fileData = {
                  name: input.files[0].name,
                  size: input.files[0].size,
                  lastModified: input.files[0].lastModified,
                  lastModifiedDate: input.files[0].lastModifiedDate,
                  type: input.files[0].type,
                  base64: e.target.result
              }
              //set var berdasarkan fildedata
              this.file_attach_invoice=fileData
            }
            reader.readAsDataURL(input.files[0]);
        }
        reader.readAsDataURL(input.files[0]);
      },
    

      //fungsi ketika ada perubahan di attach payment
      // on_change_attach_payment: function(event) {
      //   var input = event.target;
      //  if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
      //     if(input.files[0]){
      //     this.sizeTobig(input.files[0].size) 
      //     }
      //     this.resetFile('attach_payment')
      //     this.file_attach_payment_text = null
      //     this.file_attach_payment = null
      //     return
      //   }
      //   if (input.files) {
      //     var reader = new FileReader();
      //     //read file
      //     reader.onload = (e) => {
      //       //set array filedata
      //       const fileData = {
      //             name: input.files[0].name,
      //             size: input.files[0].size,
      //             lastModified: input.files[0].lastModified,
      //             lastModifiedDate: input.files[0].lastModifiedDate,
      //             type: input.files[0].type,
      //             base64: e.target.result
      //         }
      //         //set var berdasarkan fildedata
      //         this.file_attach_payment=fileData
      //       }
      //       reader.readAsDataURL(input.files[0]);
      //   }
      // },

    sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },

    async confirmation() {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addProcurementOrder()
        }
      });
    },

      //fungsi mengirimkan data ke server
      async addProcurementOrder() {
        //panggil fungsi getdata di child untuk mendapatkan data didalam child tersebut
        this.$refs.childItemComponent.getData()
        //buat var data
        const data = {
          type: "workshop_procurement_orders",
          // procurement_order_no : this.procurement_order.procurement_order_no,
          procurement_order_remark : this.procurement_order.procurement_order_remark,
          procurement_order_dealer_id: this.procurement_order.procurement_order_dealer_id,
          procurement_order_attach_quotation: this.file_attach_quotation,
          procurement_order_attach_po: this.file_attach_po,
          procurement_order_attach_invoice: this.file_attach_invoice, 
          // procurement_order_attach_payment: this.file_attach_payment,
          procurement_order_item: this.procurement_order.item
        }

        console.log(data)

        try {
          //kirim data add
        await this.$store.dispatch("workshop_procurement_order/add", data);
        //panggil alert sukses
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        //kembali ke list
        // await this.$router.replace({name: 'List Procurement Order'});
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        //panggil alert error
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      },
      //fungsi untuk meyimpan data yang diambil dari fungsi getdata di child ketika di execute
      dataItems (value) {
        this.procurement_order.procurement_order_dealer_id = value.procurement_order_dealer_id
        this.procurement_order.item = value.item
      },
      //check validasi form di child
      async validateForm() {
      // const procurement_order_no = this.$refs['procurement_order_no'];
      const childItemComponent = this.$refs['childItemComponent'];
      
      let result = []
      // result.push(
      //     await procurement_order_no.validate().then(function(data){
      //     return data.valid
      //     })
      // )
      result.push(
        await childItemComponent.validateForm().then(function(data){
          return data
        })
      )  
        
      return result.every(Boolean)
    },
    
    validateStep() {
      return this.validateForm()
    }

    },
};
</script>
<style lang="scss" scoped>

.photo_list{
    max-width: 50%;
    height: auto;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
}
</style>